import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, Spinner } from '@vwfs-bronson/bronson-react';
import { loadingSelectors } from '../../../services/redux/features/loading.slice';

export const CustomModal = ({
  title = null,
  openModal,
  setOpenModal,
  children,
  confirmText,
  cancelText,
  center = false,
}: any) => {
  const isLoading = useSelector(loadingSelectors.selectLoading);

  return (
    <Modal
      buttonConfirmText={confirmText}
      title={title}
      shown={openModal}
      center={center}
      onClose={() => setOpenModal(false)}
      onConfirm={() => setOpenModal(false)}
      onCancel={() => setOpenModal(false)}
      buttonCloseLabel="Close window."
      buttonConfirmLabel="Close window."
      buttonConfirmType="button"
      asPortal
      className="c-modal--large"
      buttonCancelText={cancelText || ''}
    >
      <>
        {children}
        {/* TODO Remove when Bronson fixes BRONSD-1042 */}
        {isLoading && <Spinner fullPage />}
      </>
    </Modal>
  );
};
